export default [
  {
    path: '/renove_exports',
    name: 'RenoveExports',
    component: () => import("@/components/data_export/RenoveExports.vue"),
    meta: {
      auth: true,
      roles: ['Director']
    },
  },
]